import { useTran } from "@/hooks";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import { Button } from "@/components/ui/button";
import { PATHS } from "@/lib/router";
import ManageUserCard from "../components/ManageUserCard";

const ManageUserPage = () => {
  const { t } = useTran();
  const navigate = useNavigate();

  return (
    <div className="flex h-dvh min-h-0 flex-col gap-4 overflow-hidden">
      {/* Header */}
      <div className="shrink-0">
        <Button
          variant="ghost"
          onClick={() => navigate(PATHS.USER_LIST)}
          className="w-full justify-start gap-2 sm:w-auto"
        >
          <ArrowLeft className="h-4 w-4" />
          {t("Back to user list")}
        </Button>
      </div>

      {/* Content */}
      <div className="min-h-0 flex-1 overflow-hidden">
        <ManageUserCard />
      </div>
    </div>
  );
};

export default ManageUserPage;
